import {
  clientActionSubscribe,
  clientActionUnsubscribe,
  EntityTypeEnum,
  FilterOperation,
  SpreadsheetUploadIdentifier,
  SubscribeType
} from 'api'
import { v4 as uuidv4 } from 'uuid'

import { ActionsUnion, createAction } from 'utils'

const mteUploadDealsSubscribe = (tradeIds: string[], correlationId: string) =>
  clientActionSubscribe({
    correlationId,
    entityTypeEnum: EntityTypeEnum.DEAL,
    preDefinedFilter: null,
    filters: [
      {
        fieldName: 'tradeId',
        value: tradeIds.join(','),
        filterOperation: FilterOperation.CONTAINS,
        orFilter: null,
        andFilter: null,
        calculatedValueType: null
      }
    ],
    postTransformFilters: [],
    subscribeType: SubscribeType.FILTERED,
    subscriptionIdentifier: SpreadsheetUploadIdentifier.MTE_UPLOAD,
    limitResults: false,
    pageNumber: null,
    pageSize: null,
    summaryRequest: null
  })

const mteUploadUnsubscribe = () =>
  clientActionUnsubscribe({ entityTypeEnum: EntityTypeEnum.DEAL, subscriptionIdentifier: SpreadsheetUploadIdentifier.MTE_UPLOAD })

export enum SpreadsheetUploadActionTypes {
  MTE_DEALS_UPLOADED_ACTION = 'MTE_DEALS_UPLOADED_ACTION',
  MTE_DEALS_SNAPSHOT_RECEIVED_ACTION = 'MTE_DEALS_SNAPSHOT_RECEIVED_ACTION',
  MTE_DEALS_SNAPSHOT_ERROR_ACTION = 'MTE_DEALS_SNAPSHOT_ERROR_ACTION'
}

const mteDealsUploaded = (tradeIds: string[]) =>
  createAction(SpreadsheetUploadActionTypes.MTE_DEALS_UPLOADED_ACTION, {
    correlationId: uuidv4(),
    tradeIds
  })

const mteUploadSnapshotReceived = () => createAction(SpreadsheetUploadActionTypes.MTE_DEALS_SNAPSHOT_RECEIVED_ACTION)
const mteUploadSnapshotError = () => createAction(SpreadsheetUploadActionTypes.MTE_DEALS_SNAPSHOT_ERROR_ACTION)

export const SpreadsheetUploadActions = {
  mteDealsUploaded,
  mteUploadDealsSubscribe,
  mteUploadSnapshotReceived,
  mteUploadSnapshotError,
  mteUploadUnsubscribe
}

export type SpreadsheetUploadActions = ActionsUnion<typeof SpreadsheetUploadActions>
